<template>
    <div class="div-main">
        <Loading v-if="loading" type="line" :center="false" />
        <div v-if="funnels.length == 0 && !loading">
            Nenhum quadro encontrado!
        </div>
        <div v-else class="side-by-side" v-for="funnel in funnels">
            <div class="molded-funnel">
                <div class="icon-funnel">
                    <div class="side-by-side">
                        <div class="funnel-name title">
                            {{ funnel.name }}
                        </div>
                    </div>
                </div>
                <div class="div-allowed">
                    <div v-html="funnel.allowedUsers"></div>
                </div>
                <div class="div-btn">
                    <div v-b-tooltip.hover title="Ver Quadro" class="side-by-side icon-btn" @click="navegateTo(funnel)">
                        <i class="fa-solid fa-chart-kanban title"></i>
                    </div>
                    <div v-b-tooltip.hover title="Editar Quadro" class="side-by-side icon-btn" @click="update(funnel)">
                        <i class="fa-solid fa-pen-to-square title"></i>
                    </div>
                    <div class="side-by-side icon-btn icon-trash" @click="confirmDelete(funnel)">
                        <i class="fa-solid fa-trash"></i>
                    </div>
                </div>
            </div>
        </div>
        <Modal title="Tem certeza que deseja excluir?" :width="500" v-if="showModal('confirmDelete')">
            <div class="text-center">
                <Button _key="btnRemove" type="danger" title="Sim, confirmar" size="medium" :clicked="remove" />
            </div>
        </Modal>
    </div>
</template>
<script>

import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
    name: "FrameList",
    components: {
        Modal, Button, Loading
    },
    data() {
        return {
            urlGetAll: "/api/v1/planner/funnel/get-all",
            urlDeleteAllApi: "/api/v1/planner/funnel/delete",
            funnels: [],
            frameSelected: {},
            loading: true,
        }
    },
    created() {
        this.getAll();
    },
    computed: {
        ...mapState("user", ["userLogged"]),
        ...mapGetters("generic", ["event", "showModal"]),
    },
    methods: {
        ...mapActions("generic", ["getApi", "deleteAllApi"]),
        ...mapMutations("generic", ["addEvent", "openModal", "hideModal", "removeLoading"]),
        getAll() {
            let params = { url: this.urlGetAll, obj: { any: this.userLogged.user.id } };
            this.getApi(params).then((response) => {
                this.funnels = response.content.data;
                this.loading = false;
            });
        },
        confirmDelete(funnel) {
            this.frameSelected = funnel;
            this.openModal("confirmDelete");
        },
        update(funnel) {
            this.addEvent({ name: "funnelUpdate", data: funnel });
        },
        remove() {
            let params = {
                url: this.urlDeleteAllApi,
                selected: [this.frameSelected.id],
            };

            this.deleteAllApi(params).then((response) => {
                if (response.success) {
                    this.hideModal("confirmDelete");
                    this.getAll();
                }
                this.removeLoading(["btnRemove"]);
            });
        },
        navegateTo(funnel) {
            this.$router.push({
                name: "kanbanList",
                params: { id: funnel.id, name: funnel.name }
            });
        }
    },
    watch: {
        event: {
            handler(event) {
                if (event.name == "funnelCreated" || event.name == "funnelUpdated") {
                    this.getAll();
                }
            },
            deep: true,
        },
    },
};
</script>

<style style>
.div-main {
    margin-top: 40px;
}

.molded-funnel {
    border: 1px solid #e8eaed;
    background-color: white;
    border-radius: 10px !important;
    width: 320px;
    margin-right: 15px;
    margin-bottom: 15px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
}

.icon-funnel {
    font-size: 18px;
}

.funnel-name {
    margin-bottom: -10px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.div-description {
    font-size: 12px;
    padding-bottom: 50px;
}

.div-user-funnel {
    margin-left: -10px;
}

.img-user-funnel {
    width: 25px;
    height: 25px;
    border-radius: 100px;
}

.div-allowed {
    margin-left: 10px;
}

.div-btn {
    margin-top: 15px;
    margin-bottom: 10px;

}

.icon-btn {
    margin-right: 20px;
    font-size: 17px;
    cursor: pointer;
    color: grey;
}

.icon-btn:hover {
    color: black;
}


.icon-trash {
    color: red;
}

.icon-trash:hover {
    color: rgb(245, 92, 92) !important;
}
</style>